import type { ChatThreadCurrentUserStatus } from './chatThreadCurrentUserStatus';
import type { ChatThreadParticipantsItem } from './chatThreadParticipantsItem';

export interface ChatThread {
  chatRoomId: number;
  createdAt: string;
  currentUserStatus?: ChatThreadCurrentUserStatus;
  isGroupThread: boolean;
  /** @nullable */
  lastMessage?: string | null;
  /** @nullable */
  lastMessageTime?: string | null;
  participants: ChatThreadParticipantsItem[];
  /** @nullable */
  unreadMessageCount?: number | null;
}
